import { ReactNode } from 'react';

import { Box, Flex } from '@bonusly/design-system';

interface BizySidePanelHeaderProps {
	left: ReactNode;
	pl?: number;
	right?: ReactNode;
}

export function BizySidePanelHeader({ left, pl = 5, right }: BizySidePanelHeaderProps) {
	return (
		<Flex align="center" justify="space-between" gap={0} pl={pl} pr={3} py={{ base: 4, sm: 3 }} flexShrink={0} minH="68px">
			<Box minW={0} flex={1} overflow="hidden">
				{left}
			</Box>
			{right && <Box flexShrink={0}>{right}</Box>}
		</Flex>
	);
}
